/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Vocabulary_TitleInputs */



/**
* | output |
* | --- |
* | "Custom Vocabulary" |
*
* @param {Custom_Vocabulary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_vocabulary_title = /** @type {((inputs?: Custom_Vocabulary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Vocabulary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vocabulaire personnalisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefiniertes Vokabular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vocabolario personalizzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательский словарь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vocabulario personalizado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义词汇")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム語彙")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम शब्दावली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vocabulário personalizado")
	return /** @type {LocalizedString} */ ("Custom Vocabulary")
});